exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkboxCronType {\r\n    float: right;\r\n    min-width: 513px;\r\n}\r\n.checkboxCronType label {\r\n    padding-left: 7px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/cross-points/cross-points.component.css
// module id = ../../../../../src/app/_components/cross-points/cross-points.component.css
// module chunks = main